import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, OnInit, Output } from '@angular/core';
import { SchoolClass } from '../../../core/models/school-class.model';
import { FormsModule, NgModel } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';

export interface StudentsFilterOptions {
  grade: string;
  class: string;
  extraSupport: string;
}

@Component({
  selector: 'wf-students-filter',
  templateUrl: './students-filter.component.html',
  styleUrls: ['./students-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    FormsModule
  ]
})
export class StudentsFilterComponent implements OnInit {
  @Input() classes: SchoolClass[] = [];
  readonly filterClass = input(true);
  @Input() filterExtraSupport: boolean = false;
  @Input() showAllGradeOption: boolean = true ;
  readonly emitOnNewData = input(false);
  @Output() filterChangeEvent = new EventEmitter<StudentsFilterOptions>();
  supportOptions: string[] = ['All', 'Yes', 'No'];
  selectedGrade: string = '' ;
  selectedClass: string = '0';
  selectedExtraSupport: string = '' ;
  elementaryGrades: string[] = [] ;
  secondaryGrades: string[] = [] ;

  constructor() {}

  @Input() set grades(grades: string[]) {
    this.elementaryGrades = [] ;
    this.secondaryGrades = [] ;

    grades.forEach((grade) => {
      // Handle our special cases
      if (grade.toLowerCase() === 'k') {
        this.elementaryGrades.push(grade) ;
        return ;
      }

      if (grade.toLowerCase() === 'other') {
        this.secondaryGrades.push(grade) ;
        return ;
      }

      let gradeNum = parseInt(grade) ;
      if (isNaN(gradeNum)) return ;

      if (gradeNum < 5) this.elementaryGrades.push(grade) ;
      else this.secondaryGrades.push(grade) ;
    }) ;

    if (this.showAllGradeOption) this.selectedGrade = 'all' ;
    else if (this.elementaryGrades.length) this.selectedGrade = 'four_below_all' ;
    else if (this.secondaryGrades.length) this.selectedGrade = 'five_up_all' ;

    if (this.emitOnNewData()) {
      this.updateStudentFilter();
    }
  }

  ngOnInit(): void {
    this.selectedClass = (this.classes.length > 0) ? `${this.classes[0].schoolClassID}` : '0' ;
    this.selectedExtraSupport = this.supportOptions[0] ;

    if (this.showAllGradeOption) this.selectedGrade = 'all' ;
    else if (this.elementaryGrades.length) this.selectedGrade = 'four_below_all' ;
    else if (this.secondaryGrades.length) this.selectedGrade = 'five_up_all' ;
  }

  updateStudentFilter() {
    this.filterChangeEvent.emit(this.getFilterSettings()) ;
  }

  getFilterSettings() {
    return {
      grade: this.selectedGrade,
      class: this.selectedClass,
      extraSupport: this.filterExtraSupport ? this.selectedExtraSupport : 'all'
    }
  }

  resetFilterSettings() {
    if (this.showAllGradeOption) this.selectedGrade = 'all' ;
    else if (this.elementaryGrades.length) this.selectedGrade = 'four_below_all' ;
    else if (this.secondaryGrades.length) this.selectedGrade = 'five_up_all' ;

    this.selectedClass = (this.classes.length > 0) ? `${this.classes[0].schoolClassID}` : '0 ' ;
    this.selectedExtraSupport = this.supportOptions[0] ;
  }
}
